var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import OtherClickListener from '../../../../../events/OtherClickListener';
import { propBool, propStr, propFunc, propArrayShape, } from '../../../../../helpers/custom-prop-types';
import { useBoolState, usePromiseDoingCallback, useUnmountRef, } from '../../../../../helpers/use/useHook';
import DirectoryIcon from '../../../../Icon/Svg/DirectoryIcon';
import ModalPortal from '../../../../Ui/Modal/ModalPortal';
import AddFolderModal from '../../../../Ui/SlideSearch/Modal/AddFolderModal';
import Hover from '../../../../Ui/System/Hover';
import ActionSave from './ActionSave';
const ActionSaveButton = (props) => {
    const { buttonClassName, className, folders, onClickSaveFolder: originalOnClickSave, onSubmitCreateFolder: originalOnSubmitCreateFolder, selectSlides, showBg, } = props;
    const unMountRef = useUnmountRef();
    const isEmptyList = !!(selectSlides && selectSlides.length === 0);
    const ref = useRef();
    const { boolState, changeFalse, changeToggle, changeTrue } = useBoolState(false);
    const { boolState: createBoolState, changeFalse: createChangeFalse, changeTrue: createChangeTrue, } = useBoolState(false, changeFalse);
    const onBack = useCallback(() => {
        createChangeFalse();
        changeTrue();
    }, [createChangeFalse, changeTrue]);
    useEffect(() => {
        const index = OtherClickListener.setListener(ref.current, changeFalse);
        return () => OtherClickListener.deleteListener(index);
    }, [ref, changeFalse]);
    const initialValues = useMemo(() => ({
        slides: selectSlides,
    }), [selectSlides]);
    const rawOnClickSave = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        yield originalOnClickSave(e, selectSlides);
        if (!unMountRef.current) {
            changeFalse();
            createChangeFalse();
        }
    }), [
        originalOnClickSave,
        selectSlides,
        changeFalse,
        createChangeFalse,
        unMountRef,
    ]);
    const [onClickSave, loadingSave] = usePromiseDoingCallback(rawOnClickSave, unMountRef);
    const onSubmitCreateFolder = useCallback((...arg) => __awaiter(void 0, void 0, void 0, function* () {
        yield originalOnSubmitCreateFolder(...arg);
        if (!unMountRef.current) {
            changeFalse();
            createChangeFalse();
        }
    }), [originalOnSubmitCreateFolder, changeFalse, createChangeFalse, unMountRef]);
    const modals = (_jsxs(_Fragment, { children: [_jsx(ActionSave, { className: className, folders: folders, hideModal: changeFalse, isShow: boolState, loading: loadingSave, onClickAdd: createChangeTrue, onClickSave: onClickSave, showBg: showBg }), _jsx(AddFolderModal, { hideModal: createChangeFalse, initialValues: initialValues, isShow: createBoolState, onBack: onBack, onSubmit: onSubmitCreateFolder })] }));
    return (_jsxs("div", Object.assign({ className: 'slide_action_button_box', ref: ref }, { children: [_jsx(Hover, { children: _jsxs("div", Object.assign({ className: 'slide_action_button_box_content' }, { children: [_jsx("button", Object.assign({ className: clsx('icon_box', buttonClassName), disabled: isEmptyList || loadingSave, onClick: changeToggle, type: 'button' }, { children: _jsx(DirectoryIcon, {}) })), _jsx("span", Object.assign({ className: 'button_text' }, { children: "\u4FDD\u5B58" }))] })) }), className === 'footer_action_save_modal' ? (_jsx(ModalPortal, { children: modals })) : (modals)] })));
};
ActionSaveButton.propTypes = {
    buttonClassName: propStr().isRequired,
    className: propStr().isRequired,
    folders: propArrayShape().isRequired,
    onClickSaveFolder: propFunc().isRequired,
    onSubmitCreateFolder: propFunc().isRequired,
    selectSlides: propArrayShape().isRequired,
    showBg: propBool(),
};
ActionSaveButton.defaultProps = {
    showBg: false,
};
export default ActionSaveButton;
